import React from 'react';

export default function FinanceIcon() {
	return (
		<svg width="100%" height="100%" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
			<mask id="mask0_1077_14829" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="41" height="41">
				<rect x="0.167969" y="0.819702" width="40" height="40" fill="#D9D9D9" />
			</mask>
			<g mask="url(#mask0_1077_14829)">
				<path d="M11.8333 34.153V30.8197H8.5V10.8197H11.8333V7.48633H15.1667V10.8197H18.5V30.8197H15.1667V34.153H11.8333ZM11.8333 27.4863H15.1667V14.153H11.8333V27.4863ZM25.1667 34.153V25.8197H21.8333V14.153H25.1667V7.48633H28.5V14.153H31.8333V25.8197H28.5V34.153H25.1667ZM25.1667 22.4863H28.5V17.4863H25.1667V22.4863Z" fill="#2D3846" />
			</g>
		</svg>
	);
}
